import React from 'react';
import { Button, Icon } from 'ui-library';
import { ICON_TYPE_EDIT } from 'ui-library/components/Icon';

const AdministrationFees = ({
    setShowAdministrationFeeModal, defaultFee, AdministrationFee, t, disableEdit = false,
}) => (
    <>
        <div className="FeeOverview__CustodyWrapper">
            <p>{t('AdministrationFee.label')}</p>
        </div>
        <div className="FeeOverview__CustodyWrapper">
            <b>
                {AdministrationFee ?? defaultFee}
                %
            </b>
        </div>
        <div className="FeeOverview__CustodyWrapper">
            {!disableEdit && (
                <Button type="link" onClick={() => setShowAdministrationFeeModal(true)} className="action-button">
                    <Icon type={ICON_TYPE_EDIT}/>
                    {t('interaction.edit')}
                </Button>
            )}
        </div>
    </>
);

export default AdministrationFees;
